import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// CSS Import
import "./index.css";

// MUI Imports
import { Tooltip, tooltipClasses } from "@mui/material";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

// COMPONENETS Imports
import Footer from "../../../../components/LandingPage/Footer";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";

// SVG Import
import BackToTop from "../../../../assets/landingPage/TopArrow.svg";

const ContactUs = () => {
  // useState
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [location, setLocation] = useState("mumbaiHead");

  const locations = {
    mumbaiHead:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3451.8779791938423!2d72.83196553488769!3d19.061905799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9e5d90b55e5%3A0x5405fcb4888919ab!2sQ2Pay%20Technologies%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1774605109402!5m2!1sen!2sin",
    mumbai:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1885.6372328408952!2d72.83027633591264!3d19.05166649798471!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c93f3228b1d9%3A0x3bbcfaf779efad37!2sMumbai%20Educational%20Trust%20(MET)!5e0!3m2!1sen!2sin!4v1750320664683!5m2!1sen!2sin",
    pune: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3462.343957875147!2d73.7744179829855!3d18.552596999154677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf4ed799eba1%3A0xd54baaeff505af5f!2sAmbrosia%20Galaxy!5e1!3m2!1sen!2sin!4v1774604920044!5m2!1sen!2sin",
  };
  const addresses = {
    mumbaiHead: `Mumbai - Fifth floor, Cozy Nook 30, 36 cross, Linking Rd, opposite Bademiya,<br/> Khar, Bandra West, Mumbai, Maharashtra 400050`,
    mumbai: `Mumbai - <span style={{"whiteSpace: nowrap;}}">7<sup>th</sup></span> floor A wing, Mumbai Educational Trust (MET, Bhujbal Knowledge City, opposite Lilavati Hospital, Reclamation, Bandra West, Mumbai, Maharashtra 400050`,
    pune: `Pune - Q2Pay Technologies Private Limited,  <span style={{"whiteSpace: nowrap;}}">17<sup>th</sup></span>  Floor, Ambrosia Galaxy, 33/1, Hill Road, Baner, Pune - 411069`,
  };

  const addressChangeData = () => {
    const address = addresses[location];
    const [city, ...rest] = address.split(" - ");
    const formattedCity = city
      .replace(
        "Mumbai",
        `<span style="color: var(--pending); font-weight: var(--font-semibold);">Mumbai</span>`,
      )
      .replace(
        "Pune",
        `<span style="color: var(--pending); font-weight: var(--font-semibold);">Pune</span>`,
      );
    const plainAddress = address.replace(/<\/?[^>]+(>|$)/g, "");

    return (
      <Tooltip
        componentsProps={{
          popper: {
            sx: {
              [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: (theme) => theme.palette.common.black,
              },
              zIndex: "2147483647 !important",
            },
          },
        }}
        title={plainAddress}
      >
        <p
          className="line-clamp-3 text-center text-xs"
          dangerouslySetInnerHTML={{
            __html: `${formattedCity} - ${rest.join(" - ")}`,
          }}
        />
      </Tooltip>
    );
  };

  // useSelector
  const { mobilestatus, webstatus } = useSelector(
    (state) => state.landingpagestate,
  );

  // useEffect
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    });
  }, [scrollPercent]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };
  }, []);

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "34px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}
        {isMobile ? (
          <div>
            <div
              style={{
                overflowY: mobilestatus && "hidden",
                height: "100vh",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
              }}
              className="bg-[#031f4f]"
            >
              <div className="flex flex-col gap-2.5 text-text-primary bg-[#1D3A6D]">
                <div className="flex flex-col justify-center relative mt-[88px] px-4">
                  <div className="text-left">
                    <h2 className="text-font-md font-semibold pb-padding-xs text-text-primary">
                      Get in <span className="text-pending">touch</span>
                    </h2>
                    <p className="text-text-secondary text-sm pb-padding-sm font-semibold">
                      Contact us for a quote or any help if needed.
                    </p>
                  </div>

                  <div className="flex w-width-full gap-gap-md">
                    <button
                      className={`p-padding-sm rounded-border-radius-sm w-width-full  ${
                        location === "mumbaiHead"
                          ? "bg-text-primary text-[#000000] font-semibold text-xs"
                          : "bg-[#3A5686] text-text-secondary text-xs"
                      }`}
                      onClick={() => setLocation("mumbaiHead")}
                    >
                      Mumbai - Head office
                    </button>
                    <button
                      className={`p-padding-sm rounded-border-radius-sm w-width-full ${
                        location === "mumbai"
                          ? "bg-text-primary text-[#000000] font-semibold text-xs"
                          : "bg-[#3A5686] text-text-primary text-xs"
                      }`}
                      onClick={() => setLocation("mumbai")}
                    >
                      Mumbai - Branch office
                    </button>
                    <button
                      className={`p-padding-sm rounded-border-radius-sm w-width-full  ${
                        location === "pune"
                          ? "bg-text-primary text-[#000000] font-semibold text-xs"
                          : "bg-[#3A5686] text-text-primary text-xs"
                      }`}
                      onClick={() => setLocation("pune")}
                    >
                      Pune - Branch office
                    </button>
                  </div>

                  <div className="h-full w-full flex justify-center items-center mx-auto relative">
                    <div className="w-full flex flex-col items-center py-padding-md">
                      <div className="flex flex-col Qlg:flex-row justify-center gap-4 w-width-full Qlg:w-width-base">
                        <div className="w-full h-auto Qlg:h-[150px]  flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary p-4 gap-gap-sm">
                          <SVGComponent
                            url={
                              "https://q2pay.in/new_assets/common/detail_page/address.svg"
                            }
                            height={"var(--icon-lg)"}
                            width={"var(--icon-lg)"}
                          />
                          {addressChangeData()}
                        </div>
                        <div className="w-full  h-auto Qlg:h-[150px]  flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary p-4 gap-gap-sm">
                          <SVGComponent
                            url={
                              "https://q2pay.in/new_assets/common/create_flow/contact_with_white_circle.svg"
                            }
                            height={"var(--icon-lg)"}
                            width={"var(--icon-lg)"}
                          />
                          <p className="text-xs text-font-xxs">
                            <a
                              href="tel:+919004400700"
                              className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                            >
                              +91 90044 00700
                            </a>
                          </p>
                        </div>
                        <div className="w-full h-auto Qlg:h-[150px]  flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary p-4 gap-gap-sm">
                          <SVGComponent
                            url={
                              "https://q2pay.in/new_assets/common/create_flow/contact_us_mail.svg"
                            }
                            height={"var(--icon-lg)"}
                            width={"var(--icon-lg)"}
                          />
                          <p className="text-xs Qlg:text-font-xxs">
                            <a
                              href="https://mail.google.com/mail/?view=cm&fs=1&to=support@q2pay.in"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                            >
                              support@q2pay.in
                            </a>
                          </p>
                          <p className="text-xs Qlg:text-font-xxs">
                            <a
                              href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@q2pay.in"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                            >
                              sales@q2pay.in
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col w-full max-w-tab-width-normal  mb-margin-lg">
                    <iframe
                      src={locations[location]}
                      width="100%"
                      height="400"
                      style={{ border: 0, borderRadius: "10px" }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        ) : (
          <>
            <div
              style={{
                overflow: webstatus ? "hidden" : "",
                minHeight: "100vh",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="flex flex-col justify-center items-center relative pt-[88px] bg-[#1D3A6D] flex-1">
                <div className="text-center">
                  <h2 className="text-font-xl pb-2 text-text-primary font-semibold">
                    Get in <span className="text-pending">touch</span>
                  </h2>
                  <p className="text-text-secondary text-xs">
                    Contact us for a quote or any help if needed.
                  </p>
                </div>

                <div className="h-full max-w-[1440px] w-screen flex justify-center mx-auto relative">
                  <div className="w-full flex flex-col items-center py-padding-md max-w-tab-width-normal">
                    <div className="flex justify-center gap-gap-md w-width-full">
                      <div className="w-[155px] flex flex-col items-center space-y-4">
                        <button
                          className={`px-4 py-2 rounded-lg w-[155px] min-h-[37px] ${
                            location === "mumbaiHead"
                              ? "bg-text-primary text-[#000000] font-semibold text-font-xs"
                              : "bg-[#3A5686] text-text-primary text-font-xs"
                          }`}
                          onClick={() => setLocation("mumbaiHead")}
                        >
                          Mumbai - Head office
                        </button>
                        <button
                          className={`px-4 py-2 rounded-lg w-[155px] min-h-[37px] ${
                            location === "mumbai"
                              ? "bg-text-primary text-[#000000] font-semibold text-font-xs"
                              : "bg-[#3A5686] text-text-primary text-font-xs"
                          }`}
                          onClick={() => setLocation("mumbai")}
                        >
                          Mumbai - Branch office
                        </button>
                        <button
                          className={`px-4 py-2 rounded-lg w-[155px] h-[37px] ${
                            location === "pune"
                              ? "bg-text-primary text-[#000000] font-semibold text-font-xs"
                              : "bg-[#3A5686] text-text-primary text-font-xs"
                          }`}
                          onClick={() => setLocation("pune")}
                        >
                          Pune - Branch office
                        </button>
                      </div>

                      <div className="Qlg:w-width-sm-1-3 gap-gap-sm p-padding-sm flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary ">
                        <SVGComponent
                          url={
                            "https://q2pay.in/new_assets/common/detail_page/address.svg"
                          }
                          height={"var(--icon-lg)"}
                          width={"var(--icon-lg)"}
                        />
                        {addressChangeData()}
                      </div>

                      <div className="border-r-[1px] border-pending"></div>
                      <div className="Qlg:w-width-sm-1-3 gap-gap-sm p-padding-sm flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary ">
                        <SVGComponent
                          url={
                            "https://q2pay.in/new_assets/common/create_flow/contact_with_white_circle.svg"
                          }
                          height={"var(--icon-lg)"}
                          width={"var(--icon-lg)"}
                        />
                        <p className="text-font-xxs">+91 90044 00700</p>
                      </div>

                      <div className="border-r-[1px] border-pending"></div>
                      <div className="Qlg:w-width-sm-1-3 gap-gap-sm p-padding-sm flex flex-col items-center justify-center border border-pending rounded-xl text-text-primary">
                        <SVGComponent
                          url={
                            "https://q2pay.in/new_assets/common/create_flow/contact_us_mail.svg"
                          }
                          height={"var(--icon-lg)"}
                          width={"var(--icon-lg)"}
                        />
                        <p className="text-font-xxs">
                          <a
                            href="https://mail.google.com/mail/?view=cm&fs=1&to=support@q2pay.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                          >
                            support@q2pay.in
                          </a>
                        </p>
                        <p className="text-font-xxs">
                          <a
                            href="https://mail.google.com/mail/?view=cm&fs=1&to=sales@q2pay.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer border-b border-current hover:border-pending hover:text-pending"
                          >
                            sales@q2pay.in
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex w-full max-w-tab-width-normal space-x-4 mb-margin-lg justify-end">
                  <iframe
                    src={locations[location]}
                    width="100%"
                    height="400"
                    style={{ border: 0, borderRadius: "10px" }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>

              <Footer />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
